import React from 'react';
import Loading from 'react-loading';
import axios from 'axios';
import 'react-select/dist/react-select.css';

import CommentItem from './CommentItem';
import CommentBox from './CommentBox';

class Comment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        	commentArr: [],
			start: 0,
			limit: 5,
			end: 0,
			comments: [],
            addComment: false,
            joined: this.props.joined,
            leftOpend: this.props.leftOpend,
            id_joined: this.props.id_joined,
            comment_loading: true
        };
        this.getComments = this.getComments.bind(this);
		this.generateComment = this.generateComment.bind(this);
    }

	componentDidMount() {}

	componentWillReceiveProps(nextProps) {
        if (this.props.justPost != nextProps.justPost || this.props.id_joined != nextProps.id_joined || (this.props.leftOpend != nextProps.leftOpend && nextProps.leftOpend == 1)) {
            this.setState({start: 0, commentArr: [], comment_loading: true}, () => {
                this.getComments(this.props.joined.id_joined, this.state.start);
            });
        }
    }

    getComments = (id_joined, start) => {
        axios.get('/code/api_experiences.php?api=getExperientialComments&id_joined=' + id_joined + '&start=' + start)
            .then(response => {
                if (parseInt(response.data.status) === 1) {
                    let end = start + response.data.data.length;
                    let comments = [];
                    comments = comments.concat(response.data.data);
                    this.setState({end: end, comments: comments}, () => {
                        this.generateComment(this.state.comments)
                    });
                }
                return response;
            });
    }

    generateComment = (comments) => {
        let newArry = [];
        if (comments.length > 0) {
            for (var c_item of comments) {
                newArry.unshift(
                    <CommentItem
						key={"comment-" + c_item.id_comment}
						user={this.props.user}
                        onChange={this.handleCommentChange.bind(this)}
                        joined={this.props.joined}
						comment={c_item}
					/>
                )
            }
            // Usage!
            this.sleep(200).then(r => {
                this.setState({comment_loading: false, commentArr: newArry});
            })
        }
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }


    handleComment = (comment) => {
        let comments = this.state.comments;
        comments.unshift(comment);
        this.setState({comments: comments, addComment: true}, () => {
            this.generateComment(this.state.comments)
        });
    }

    handleCommentChange = (comment, type = "update") => {
        let commentList = this.state.comments;
        for (let i = 0; i < commentList.length; i++) {
            if (parseInt(commentList[i].id_comment) === parseInt(comment.id_comment)) {
                if(type == "delete")
                {
                    commentList.splice(i,1);
                }
                else {
                    commentList[i] = comment;
                }
                this.setState({comments: commentList}, () => {
                    this.generateComment(this.state.comments)
                });
                break;
            }
        }
    }

    showMore = (evt) => {
        if (parseInt(this.state.end) % parseInt(this.state.limit) === 0) {
            let start = this.state.end;
            this.setState({start: start}, () => {
                this.getComments(this.props.joined.id_joined, this.state.start);
            });
        }
    }

	render() {

        let blo =
            <div className="comment_feed_section">
                {this.state.comment_loading ?
                    <div className="show_more"><div className="center_div"><Loading type='bubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div></div>
                    :
                    ""
                }
                {this.state.commentArr}
                {parseInt(this.props.enable_ask) !== 1 ? "" :
                    <CommentBox
                        getInput={this.props.getInput}
                        user={this.props.user}
                        joined={this.props.joined}
                        enable_ask={this.props.enable_ask}
                        onComment={this.handleComment.bind(this)}
                    />
                }
            </div>

        let box =
            <CommentBox
                getInput={this.props.getInput}
                user={this.props.user}
                joined={this.props.joined}
                enable_ask={this.props.enable_ask}
                onComment={this.handleComment.bind(this)}
            />


        if (this.props.joined.comments_count > 0 || this.state.addComment) {
            return blo
        }
        else {
            return box
        }
	}
}

export default Comment;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/experiential/Comment.js
 **/